import { render } from "./OffcanvasContent.vue?vue&type=template&id=ced36990"
import script from "./OffcanvasContent.vue?vue&type=script&lang=js"
export * from "./OffcanvasContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__